import { FC } from "react";

import { TableWrapperGeneric } from "@ryde/controls";
import { IColumnDef, IExtendableDto } from "@ryde/shared";

import { BookingCrudeRoutes } from "../routes";
import { BookingsGridPanelWrapperStyled } from "./bookings.panel.styled";

interface IBookingsPanelGrid {
  tableDefs: IColumnDef<IExtendableDto, unknown>[];
}

export const BookingsPanelGrid: FC<IBookingsPanelGrid> = ({ tableDefs }) => {
  return (
    <>
      <BookingsGridPanelWrapperStyled>
        <TableWrapperGeneric
          tableDefs={tableDefs as IColumnDef<IExtendableDto, unknown>[]}
        />
      </BookingsGridPanelWrapperStyled>
      <BookingCrudeRoutes />
    </>
  );
};
